/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.6-6-gfde9e530-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BootstrapThemeColorFromJSON, BootstrapThemeColorToJSON, } from './BootstrapThemeColor';
/**
 * Check if a given object implements the TargetGroupDataRequest interface.
 */
export function instanceOfTargetGroupDataRequest(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
export function TargetGroupDataRequestFromJSON(json) {
    return TargetGroupDataRequestFromJSONTyped(json, false);
}
export function TargetGroupDataRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'color': json['color'] == null ? undefined : BootstrapThemeColorFromJSON(json['color']),
    };
}
export function TargetGroupDataRequestToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'description': value['description'],
        'color': BootstrapThemeColorToJSON(value['color']),
    };
}
